import React, { useState } from 'react';
import { ChevronDown, ChevronUp, EyeOff, Eye } from 'lucide-react';
import { formatDateRange } from '../utils/formatters';

const HiddenWeeksIndicator = ({
  hiddenWeekIndices,
  weeks,
  darkMode,
  theme,
  onUnhideWeek
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const count = hiddenWeekIndices.length;

  return (
    <div className="mb-6">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={
          'w-full py-3 px-4 rounded-xl flex items-center justify-between transition-colors ' +
          (darkMode
            ? 'bg-slate-800/50 border border-slate-700/50 hover:bg-slate-800 hover:border-slate-700'
            : 'bg-slate-50 border border-slate-200 hover:bg-slate-100 hover:border-slate-300')
        }
      >
        <div className="flex items-center gap-2">
          <EyeOff className={`w-4 h-4 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`} />
          <span className={`text-sm font-medium ${darkMode ? 'text-slate-300' : 'text-slate-600'}`}>
            {count} hidden week{count !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
            {isExpanded ? 'Collapse' : 'Expand'}
          </span>
          {isExpanded ? (
            <ChevronUp className={`w-4 h-4 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`} />
          ) : (
            <ChevronDown className={`w-4 h-4 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`} />
          )}
        </div>
      </button>

      {isExpanded && (
        <div className={
          'mt-2 rounded-xl border overflow-hidden ' +
          (darkMode ? 'bg-slate-800/30 border-slate-700/50' : 'bg-slate-50/50 border-slate-200')
        }>
          {hiddenWeekIndices.map((weekIndex, i) => {
            const week = weeks[weekIndex];
            if (!week) return null;

            return (
              <div
                key={weekIndex}
                className={
                  'px-4 py-3 flex items-center justify-between ' +
                  (i > 0 ? (darkMode ? 'border-t border-slate-700/50' : 'border-t border-slate-200') : '')
                }
              >
                <div>
                  <div className={`text-sm font-medium ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                    Week {weekIndex + 1}
                  </div>
                  <div className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-500'}`}>
                    {formatDateRange(week[0], week[6])}
                  </div>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onUnhideWeek(weekIndex);
                  }}
                  className={
                    'px-3 py-1.5 rounded-lg text-xs font-medium flex items-center gap-1.5 transition-colors ' +
                    (darkMode
                      ? 'bg-slate-700 hover:bg-slate-600 text-slate-300'
                      : 'bg-white hover:bg-slate-100 text-slate-700 border border-slate-300')
                  }
                >
                  <Eye className="w-3.5 h-3.5" />
                  Unhide
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default HiddenWeeksIndicator;
